import type { Components } from '@mui/material/styles';

const MuiMenuItem: Components['MuiMenuItem'] = {
  defaultProps: {
    href: '#'
  }
} as never;

export default MuiMenuItem;
